import React from 'react';
import { motion } from 'framer-motion';
const clients = [{
  name: 'Hextronics',
  url: 'https://www.hextronics.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5tYiH5f2RyEdnCYk8VAwKq/hextronics_dark.png'
}, {
  name: 'XBow Systems',
  url: 'https://www.xbowsystems.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fpZ38CxWMVGvw2t9cmUgRp/xbow_dark.png'
}, {
  name: 'Octoserver',
  url: 'https://www.octoserver.io',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uki8u29T2nAj9aWWE68ScR/octoserver_dark.png'
}, {
  name: 'Fredsense',
  url: 'https://www.fredsense.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2NxyvG5yHavGA567Kq28Un/fredsense_dark.png'
}, {
  name: 'Flightdeck Solutions',
  url: 'https://flightdecksolutions.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hAE2QJNs6DvEe9k3x67t5B/logo.png'
}, {
  name: 'Blissway',
  url: 'https://www.blissway.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/frH9B3w3M8vQmPVXXcg75h/blissway_dark.png'
}, {
  name: 'NLine Energy',
  url: 'https://www.nlineenergy.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5HQwJJtXU5yt9hecifgVSW/nline_dark.png'
}, {
  name: 'Flexxbotics',
  url: 'https://www.flexxbotics.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mU8u7pBeiVDbQpmpXoKRiL/flexxbotics_dark.png'
}, {
  name: 'Aclarity',
  url: 'https://www.aclarity.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wbpXt4jqn1FfCvHhFwJUUi/aclarity.png'
}];
export function Testimonials() {
  return <section className="py-24 bg-slate-50 border-t border-slate-200" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 className="text-3xl font-bold text-slate-900" data-id="element-202">
            Foundations tracks ERP implementations at
          </h2>
        </div>

        {/* Client Logo Carousel */}
        <div className="overflow-hidden" data-id="element-203">
          <motion.div className="flex gap-12 items-center" animate={{
          x: [0, -1800]
        }} transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear',
          repeatType: 'loop'
        }} data-id="element-204">
            {/* Duplicate the array for seamless loop */}
            {[...clients, ...clients].map((client, index) => <a key={index} href={client.url} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300 group" data-id="element-205">
                <div className="flex items-center justify-center px-8 py-4 bg-white rounded-lg border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all h-20" data-id="element-206">
                  {client.logo ? <img src={client.logo} alt={client.name} className="h-12 w-auto object-contain" data-id="element-207" /> : <div className="flex items-center gap-2" data-id="element-208">
                      <div className="h-8 w-8 bg-slate-800 rounded" data-id="element-209"></div>
                      <span className="font-semibold text-slate-800 text-lg whitespace-nowrap" data-id="element-210">
                        {client.name}
                      </span>
                    </div>}
                </div>
              </a>)}
          </motion.div>
        </div>
      </div>
    </section>;
}